import DashboardIcon from '@mui/icons-material/Dashboard';
import PeopleIcon from '@mui/icons-material/People';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import SubjectIcon from '@mui/icons-material/Subject';
import GridViewIcon from '@mui/icons-material/GridView';
import AssessmentIcon from '@mui/icons-material/Assessment';
import Reports from '@mui/icons-material/Report';

export default function Sidebar() {
    const location = useLocation();
    const authUser = localStorage.getItem('FF-authUser');
    const user = JSON.parse(authUser);
    const navigate = useNavigate();

    const handleLogout = () => {
        localStorage.clear();
        navigate("/");
    };
    return(
        <aside id="layout-menu" className="layout-menu menu-vertical menu bg-menu-theme">
            <div className="app-brand demo">
                <Link to="/" className="app-brand-link">
                    <span className="app-brand-logo demo">
                        <img src={process.env.REACT_APP_BASE_URL+"assets/img/first-feedback-logo-inverted.png"} alt="" height="60px" style={{width: '200px'}} />
                        
                    </span>
                    {/* <span className="app-brand-text demo text-body fw-bolder">First Feedback</span> */}
                </Link>

                <a href="#" className="layout-menu-toggle menu-link text-large ms-auto d-block d-xl-none">
                    <i className="bx bx-chevron-left bx-sm align-middle"></i>
                </a>
            </div>

            <div className="menu-inner-shadow"></div>

            <ul className="menu-inner py-1">
                <li className="menu-header small text-uppercase"><span className="menu-header-text">Menu</span></li>
                
                { user.role === 'SuperAdmin' ?
                    <>
                        {/* <li className={location.pathname === "/dashboard"? "menu-item active" : "menu-item"}>
                            <Link to="/dashboard" className="menu-link">        
                                <DashboardIcon className='menu-icon tf-icons bx bx-home-circle'/>
                                <div>Dashboard</div>
                            </Link>
                        </li> */}
                        <li className={location.pathname === "/admins"? "menu-item active" : "menu-item"}>
                            <Link to="/admins" className="menu-link">
                                <i className="menu-icon tf-icons bi bi-people"></i>
                                <div>Admins</div>
                            </Link>
                        </li>
                        <li className={location.pathname === "/email_templates"? "menu-item active" : "menu-item"}>
                            <Link to="/email_templates" className="menu-link">
                                <i className="menu-icon tf-icons bi bi-envelope"></i>
                                <div>Email Templates</div>
                            </Link>
                        </li>
                        <li className={location.pathname === "/competency_libraries"? "menu-item active" : "menu-item"}>
                            <Link to="/competency_libraries" className="menu-link">
                                <i className="menu-icon tf-icons bi bi-bullseye"></i>
                                <div>Competency Libraries</div>
                            </Link>
                        </li>
                        <li className="menu-header small text-uppercase">
                            <span className="menu-header-text">Account</span>
                        </li>
                        <li className={location.pathname === "/profile" || location.pathname === "/security"? "menu-item active" : "menu-item"}>
                            <Link to="/profile" className="menu-link">
                                <i className="bx bx-cog me-2"></i>
                                <span className="align-middle me-2">Profile</span>
                            </Link>
                        </li>
                        <li className="menu-item">
                            <span className="menu-link" onClick={() => handleLogout()} style={{cursor:'pointer'}}>
                                <i className="bx bx-power-off me-2"></i>
                                <span className="align-middle">Log Out</span>
                            </span>
                        </li>
                    </>
                : 
                    <>
                        <li className={location.pathname === "/organizations"? "menu-item active" : "menu-item"}>
                            <Link to="/organizations" className="menu-link">
                                <i className="menu-icon tf-icons bi bi-people"></i>
                                <div>Organizations</div>
                            </Link>
                        </li>
                        <li className={location.pathname === "/email_templates"? "menu-item active" : "menu-item"}>
                            <Link to="/email_templates" className="menu-link">
                                <i className="menu-icon tf-icons bi bi-envelope"></i>
                                <div>Email Templates</div>
                            </Link>
                        </li>
                        <li className={location.pathname === "/assessments" || location.pathname === "/create_assessment" ? "menu-item active" : "menu-item"}>
                            <Link to="/assessments" className="menu-link">
                            <AssessmentIcon className='menu-icon'/>
                                <div>Assessments</div>
                            </Link>
                        </li>                                                
                        <li className={location.pathname === "/competencies"? "menu-item active" : "menu-item"}>
                            <Link to="/competencies" className="menu-link">
                                <i className="menu-icon tf-icons bi bi-bullseye"></i>
                                <div>Competencies</div>
                            </Link>
                        </li>
                        <li className={location.pathname === "/survey_templates"? "menu-item active" : "menu-item"}>
                            <Link to="/survey_templates" className="menu-link">
                                <i className="menu-icon tf-icons bi bi-list-check"></i>
                                <div>Survey Templates</div>
                            </Link>
                        </li>
                        {/* <li className={location.pathname === "/subjects"? "menu-item active" : "menu-item"}>
                            <Link to="/subjects" className="menu-link">
                            <SubjectIcon className='menu-icon'/>
                                <div>Subjects</div>
                            </Link>
                        </li> */}                        
                        <li className={location.pathname === "/reports"? "menu-item active" : "menu-item"}>
                            <Link to="/reports" className="menu-link">
                            <Reports className='menu-icon'/>
                                <div>Reports</div>
                            </Link>
                        </li>
                        <li className="menu-header small text-uppercase">
                            <span className="menu-header-text">Account</span>
                        </li>
                        <li className={location.pathname === "/profile" || location.pathname === "/security"? "menu-item active" : "menu-item"}>
                            <Link to="/profile" className="menu-link">
                                <i className="bx bx-cog me-2"></i>
                                <span className="align-middle me-2">Profile</span>
                            </Link>
                        </li>
                        <li className="menu-item">
                            <span className="menu-link" onClick={() => handleLogout()} style={{cursor:'pointer'}}>
                                <i className="bx bx-power-off me-2"></i>
                                <span className="align-middle">Log Out</span>
                            </span>
                        </li>
                    </>
                }                
            </ul>
        </aside>
    )
}